import React from 'react';
import AllNewsPage from '../../pages/AllNewsPage';

const AllNewsDesktop = () => <AllNewsPage />;

export default AllNewsDesktop;
